{
	"cardHeader": "Få tilgang til erklæringene dine",
	"supplierTitle": "Er du leverandør av en evoZero-erklæring?",
	"supplierDescription": "Administrer erklæringene for evoZero-materialene dine.",
	"loginButton": "Logg inn"
}
